import { CircularProgress } from '@paysense-india-services/elevate-web'

const EmiDetailHeader = ({ data }) => {
  const { title, subtitle, meta } = data || {}
  const progress = meta?.percentage ? parseInt(meta.percentage, 10) : 0

  return (
    <div className='ew-border-bottom ew-pb-12 ew-d-flex ew-align-items-center ew-justify-content-between'>
      <div>
        <div className='ew-typography-normal ew-fw-semi-bold'>{title}</div>
        <div className='ew-color-secondary ew-fw-regular'>{subtitle}</div>
      </div>
      {progress > 0 ? <CircularProgress progress={progress} size={40} /> : null}
    </div>
  )
}

export default EmiDetailHeader
